export default class Integrations {
  constructor(api) {
    this.api = api;
  }

  getAll(queryParams, fields, onSuccess, onError) {
    if (fields != "") {
      fields = "&include=" + fields;
    }
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/third-party-apis/service" + params + fields, {
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getIntegrations(includes, onSuccess, onError) {
    let include = "";
    if (includes) {
      include = "?include=" + includes;
    }
    return this.api.http_fibercloud
      .get("v1/third-party-apis/service" + include)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getIntegrationByUuid(integrationUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/third-party-apis/service/" + integrationUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createNewImport(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/third-party-apis/import-objects-data", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  storeObjects(data, importUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .post(
        "v1/third-party-apis/import-objects-data/import/" +
          importUuid +
          "/store-objects",
        data
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getConflicts(importUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/third-party-apis/import-objects-data/import/" +
          importUuid +
          "/conflicted-objects"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getImportByUuid(importUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/third-party-apis/import-objects-data/import/" + importUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getImportNewObjects(importUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/third-party-apis/import-objects-data/import/" +
          importUuid +
          "/new-objects"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  syncWithExternalService(assetReservationID, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/third-party-apis/openreachnois/", assetReservationID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/integrations.js